import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
`;
export const Svg = styled.svg `
  height: 4rem;
  width: 4rem;
  text-align: center;
  animation: rotate 1s linear infinite;
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const Circle = styled.circle `
  ${({ theme, color }) => css `
    width: 100%;
    height: 100%;
    stroke-width: 2.5;
    stroke: #ffffff;
    stroke-linecap: round;
    stroke-dasharray: 56.5;
    stroke-dashoffset: 56.5;
    background: transparent;
    animation: animate 1.5s linear infinite;
    @keyframes animate {
      0%,
      100% {
        stroke-dashoffset: 56.5;
      }
      50% {
        stroke-dashoffset: 0;
      }
      50.1% {
        stroke-dashoffset: 112;
      }
    }
  `}
`;
//# sourceMappingURL=Spinner.styles.js.map